<div class="home-container">
    <true-breadcrumbs [subset]="this.config.subset" [assessmentName]="assessmentName + ' (' + assessmentObject + ')'"></true-breadcrumbs>
    <div class="insights-instructions">
      <p>Get instant feedback from AI on your business model. Review comments and recommendations, then send everything for expert review and export your report.</p>
    </div>
    <div class="comments-recommendations">
      <mat-card class="comments">
        <h3>Comments on business model</h3>
        <ul>
          <li *ngFor="let c of commentsList" [ngClass]="{'loading-fade': recommendationsLoading}">
            <strong>{{ c.title }}:</strong> {{ c.text }}
          </li>
        </ul>
      </mat-card>
    
      <mat-card class="recommendations">
        <h3>Recommendations for improvement</h3>
        <ul>
          <li *ngFor="let r of recommendationsList" [ngClass]="{'loading-fade': recommendationsLoading}">
            <strong>{{ r.title }}:</strong> {{ r.text }}
          </li>
        </ul>
      </mat-card>
    </div>
    <!--<p class="tagline">Improve With AI Generated Comments and Recommendations</p>-->

    <div class="section-tabs">
      <div (click)="getFeedback()" class="tab-card">
        <div class="tab-btn">
          <div class="tab-icon">
            <ng-container *ngIf="!recommendationsLoading; else loadingSpinner">
              <img src="assets/icons/auto_awesome.svg" />
            </ng-container>
            <ng-template #loadingSpinner>
              <mat-progress-spinner
                mode="indeterminate"
                diameter="24"
                strokeWidth="3"
                color="primary">
              </mat-progress-spinner>
            </ng-template>
          </div>
          <span>Get feedback</span>
        </div>
        <p class="tagline">Get Initial Comments and Recommendations From AI</p>      
      </div>
      <div (click)="sendForReview()" class="tab-card">
        <div class="tab-btn">
          <img src="assets/icons/paper-plane-solid.svg">
          <span>Send for review</span>
        </div>
        <p class="tagline">Get Final Opinion From Human Expert</p>
      </div>
    </div>
</div>
